import React from 'react';
import {
    IoAlertCircleOutline,
    IoCheckmarkCircleOutline,
    IoInformationCircleOutline,
} from 'react-icons/io5';
import './toast.css';

/**
 * Универсальное всплывающее уведомление (тост) в правом верхнем углу.
 *
 *   <Toast key={id} title="Сохранено" status="success" />
 *
 * status: "success" (по умолчанию) | "error" | "fail" | "info"
 *
 * Компонент сам скрывается через ~3.4 с (анимация объявлена в toast.css).
 * Чтобы показать новое уведомление, меняйте `key` — компонент
 * перемонтируется и таймер начнётся заново.
 */
const ICONS = {
    success: IoCheckmarkCircleOutline,
    error: IoAlertCircleOutline,
    fail: IoAlertCircleOutline,
    info: IoInformationCircleOutline,
};

const normalizeStatus = (status) => {
    const value = String(status || '').trim().toLowerCase();
    if (value === 'success' || value === 'ok') return 'success';
    if (value === 'error') return 'error';
    if (value === 'fail' || value === 'failed') return 'fail';
    return 'info';
};

const Toast = ({ title, status = 'success' }) => {
    if (!title) return null;

    const kind = normalizeStatus(status);
    const Icon = ICONS[kind] || IoInformationCircleOutline;

    return (
        <div className={`toast-block ${kind}`} role="status" aria-live="polite">
            <span className="toast-block__icon" aria-hidden="true">
                <Icon />
            </span>
            <span className="toast-block__text">{title}</span>
        </div>
    );
};

export default Toast;
